// [CASH-MODE] Coloured UPI / Cash badge for table rows.
import React from 'react';
import { Chip } from '@mui/material';
import { rowPaymentMode } from '../utils/paymentMode';
import { PAYMENT_MODES } from '../constants/paymentModes';

const PaymentModeChip = ({ row, mode, size = 'small' }) => {
  const value = mode ? String(mode).toUpperCase() : rowPaymentMode(row);
  const isCash = value === PAYMENT_MODES.CASH;
  return (
    <Chip
      label={isCash ? 'Cash' : 'UPI'}
      size={size}
      color={isCash ? 'warning' : 'primary'}
      variant={isCash ? 'filled' : 'outlined'}
      sx={{ fontWeight: 600, minWidth: 56 }}
    />
  );
};

export default PaymentModeChip;
